const DATA_LAYER_CAP = 200;

// The only sanctioned way to push to window.dataLayer (enforced by ESLint).
// It caps the array so long sessions don't retain unbounded event history —
// GTM collects each event at push time, so evicted entries are already processed.
export const pushToDataLayer = (message: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || [];
  // Going through `push` is required: gtm.js replaces it with its own
  // processing function once loaded. Trimming via splice is safe.
  // eslint-disable-next-line no-restricted-syntax
  window.dataLayer.push(message);
  if (window.dataLayer.length > DATA_LAYER_CAP) {
    window.dataLayer.splice(0, window.dataLayer.length - DATA_LAYER_CAP);
  }
};
